import { ExclamationCircleTwoTone } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
import EnclosedIcon, { IconProps } from './EnclosedIcon';

const ExclamationStyled = styled(ExclamationCircleTwoTone)`
  z-index: 2000;
  font-size: 14px;
  margin-right: 0px;
`;

type ExlamationIconProps = IconProps & {
};

const ExclamationIcon: React.FC<ExlamationIconProps> = (props: ExlamationIconProps) => {
  const { onClick, enclosed, color } = props;
  const icon = <ExclamationStyled twoToneColor={color ?? undefined} />;

  return <EnclosedIcon icon={icon} enclosed={enclosed} onClick={onClick} />;
};

export default ExclamationIcon;
